import { $api } from "../api"
import sanitizedConfig from "../Config"
import { IMedCard } from "../pages/Meds/types"


export const getCardsRequest = (api_url: string, query: any) => {
    return $api.get(`${api_url}/v2/cards`, {params: query})
}
export const getCardRequest = (api_url: string, id: number) => {
    return $api.get(`${api_url}/v1/cards/${id}`)
}
export const getMedicCardRequest = (api_url: string, id: number, medicId: number) => {
    return $api.post(sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL + `/v1/cards/${id}/${medicId}/take`)
}
export const getCardForMedicRequest = (medicId: number) => {
    return $api.get(sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL + `/v1/cards/medic/${medicId}`)
}
export const setMedicWorkStatusRequest = (medicId: number, payload: any) => {
    return $api.patch(sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL + `/v1/medics/${medicId}/work-status`, payload)
}
export const getCardsCount = () => {
    return $api.get(sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL + `/v1/cards/count?status=CREATED`)
}
export const getReferralsRequest = (api_url: string, query: any) => {
    return $api.get(`${api_url}/v1/cards/referrals` + `?query=${JSON.stringify(query)}`)
}
export const getMedJournalsRequest = (api_url: string, query: any) => {
    return $api.get(`${api_url}/v1/cards/med-journals` + `?page=${query?.page}&per_page=${query?.per_page}`/*`?query=${JSON.stringify(query)}`*/)
}
export const getCardsCountRequest = (api_url: string, query: any) => {
    return $api.get(`${api_url}/v1/cards/count` + `?query=${JSON.stringify(query)}`)
}
export const updateCardRequest = (api_url: string, id: number, payload: any) => {
    return $api.patch(`${api_url}/v1/cards/${id}`, {...payload/*, skip: null*/})
}
export const signCardRequest = (api_url: string, id: number, payload: any) => {
    return $api.patch(`${api_url}/v1/cards/${id}/sign`, payload)
}
export const finishCardRequest = (api_url: string, id: number, payload: any) => {
    return $api.patch(`${api_url}/v1/cards/${id}/finish`, payload)
}

export const getNormsRequest = (api_url: string) => {
    return $api.get(`${api_url}/v1/check-norms`)
}

export const getDeviationsRequest = (api_url: string, id?:number) => {
    return $api.get(id ? `${api_url}/v1/cards/${id}/deviations` : `${api_url}/v1/deviations`)
}

export const getDefectsRequest = (api_url: string) => {
    return $api.get(`${api_url}/v1/defects`)
}

export const getCertificatesRequest = (value?: any) => {
    return $api.get('/v1/cards/certificates' + (value ? `?value=${value}` : '') )
}


export const getArchiveUrlRequest = (api_url: string, id: number) => {
    return $api.get(`${api_url}/v1/cards/${id}/archive-url`)
}


export const getDriver = () => {
    return $api.get('v1/drivers')
}

export const getDriverDeviations = () => {
    return $api.get('/v1/drivers/deviations')
}
export const getDocumentsRequest=(api_url: string, status?:string, id?:number, perPage?:number, page?:number) => {
    return  $api.get(`${api_url}/v1/drivers/documents${!!status ? `/?status=${status}` : ''}${!!id ? `&id=${id}` : ''}${!!perPage ? `&per_page=${perPage}` : ''}${!!page ? `&page=${page}` : ''}`)
}
export const getDocumentForMedicRequest=(api_url: string) => {
    return  $api.get(`${api_url}/v1/drivers/document`)
}
export const updateDocumentRequest = (api_url: string, data: any) => {
    return $api.patch(`${api_url}/v1/drivers/${data.id}/documents`, data)
}


export const getFaceProcessingTask = (api_url: string, taskId: string) => {
    return $api.get(`${api_url}/v1/cards/faceprocessingtasks/${taskId}`)
}

export const getCardByDriver = (api_url: string, driverIds: string) => {
    return $api.get(`${api_url}/v1/cards/medic-by-drivers?driverIds=${driverIds}`)
}

export const getMedComlexNumbers = (api_url: string, search: any) => {
    return $api.get(`${api_url}/v1/cards/medical-complexes?per_page=10`, search ? { params: { search: search }} : undefined)
}